import { render, staticRenderFns } from "./ListSubjectTypesPublicCompany.vue?vue&type=template&id=3994c93d&"
import script from "./ListSubjectTypesPublicCompany.vue?vue&type=script&lang=js&"
export * from "./ListSubjectTypesPublicCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3994c93d')) {
      api.createRecord('3994c93d', component.options)
    } else {
      api.reload('3994c93d', component.options)
    }
    module.hot.accept("./ListSubjectTypesPublicCompany.vue?vue&type=template&id=3994c93d&", function () {
      api.rerender('3994c93d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListSubjectTypesPublicCompany.vue"
export default component.exports